import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { WalletProvider } from "./context/WalletContext";
import { ContractProvider } from "./context/ContractContext";
import { ContractServicesProvider } from "./context/ContractServicesContext";
import { ToastContainer } from "react-toastify";
import Home from "./pages/home";
import Projects from "./pages/projects";
import CreateProject from "./pages/projects/CreateProject";
import Missions from "./pages/missions";
import Innovators from "./pages/innovators";
import CollaborationHub from "./pages/collaboration-hub";
import Portfolio from "./pages/portfolio";
import ProjectDetails from "./pages/projects/ProjectDetails";
import InnovatorProfile from "./components/innovators-component/InnovatorProfile";
import PrivateLayout from "./components/layout/PrivateLayout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { TasksDetails } from "./pages/tasks";
import Doc from "./pages/doc";
import AdminDashboard from "./pages/admin";

function App() {
  return (
    <WalletProvider>
      <ContractProvider>
        <ContractServicesProvider>
          <ToastContainer position="top-right" autoClose={2000} />
          <BrowserRouter>
            <div className="min-h-screen bg-gray-50">
              <Routes>
                <Route
                  path="/"
                  element={
                    <PrivateLayout>
                      <Home />
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/projects"
                  element={
                    <PrivateLayout>
                      <Projects />
                    </PrivateLayout>
                  }
                />
                 <Route
                  path="/docs"
                  element={
                    <PrivateLayout>
                      <Doc />
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/projects/create"
                  element={
                    <PrivateLayout>
                      <ProtectedRoute>
                        <CreateProject />
                      </ProtectedRoute>
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/missions"
                  element={
                    <PrivateLayout>
                      <ProtectedRoute>
                        <Missions />
                      </ProtectedRoute>
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/innovators"
                  element={
                    <PrivateLayout>
                      <Innovators />
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/innovators/:id"
                  element={
                    <PrivateLayout>
                      <InnovatorProfile />
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <PrivateLayout>
                      <ProtectedRoute>
                        <InnovatorProfile />
                      </ProtectedRoute>
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/collaboration-hub"
                  element={
                    <PrivateLayout>
                      <ProtectedRoute>
                        <CollaborationHub />
                      </ProtectedRoute>
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/portfolio"
                  element={
                    <PrivateLayout>
                      <ProtectedRoute>
                        <Portfolio />
                      </ProtectedRoute>
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/tasks"
                  element={
                    <PrivateLayout>
                      <TasksDetails />
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/projects/token/:projectTokenId"
                  element={
                    <PrivateLayout>
                      <ProjectDetails />
                    </PrivateLayout>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <PrivateLayout>
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    </PrivateLayout>
                  }
                />
              </Routes>
            </div>
          </BrowserRouter>
        </ContractServicesProvider>
      </ContractProvider>
    </WalletProvider>
  );
}

export default App;
